import { useIsMsalAuth, useIsUserAuth } from '../..';

export function useIsAuth(): boolean {
  const isMsalAuth = useIsMsalAuth();
  const isUserAuth = useIsUserAuth();

  return !!(isMsalAuth || isUserAuth);
}
